var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { COLOR } from '../../../theme/colors';
import { Link } from '../Link';
export const ArrowLink = (_a) => {
    var { to, children, sx } = _a, rest = __rest(_a, ["to", "children", "sx"]);
    return (_jsxs(Link, Object.assign({ to: to }, rest, { sx: Object.assign({ display: 'inline-flex', whiteSpace: 'nowrap', padding: 0, flexGrow: 0, position: 'relative', boxSizing: 'border-box', bg: COLOR.WHITE, color: COLOR.PRIMARY, ':hover': {
                transform: 'scale(1.02)',
                bg: COLOR.EXTRA_EXTRA_LIGHT_GRAY,
            }, ':hover>svg': {
                fill: COLOR.EXTRA_EXTRA_LIGHT_GRAY,
            }, '>svg': {
                fill: COLOR.WHITE,
            } }, sx) }, { children: [_jsx("div", Object.assign({ sx: {
                    position: 'relative',
                    border: '1px solid #a7a7a7',
                    borderWidth: '1px 0 2px 1px',
                    boxSizing: 'border-box',
                    padding: '0.125rem 1.5rem 0.125rem 0.5rem',
                    height: '100%',
                    flex: '1 1 auto',
                } }, { children: children })), _jsxs("svg", Object.assign({ viewBox: "0 0 16 1", preserveAspectRatio: "none", sx: {
                    width: '16px',
                    right: '-16px',
                    top: '0px',
                    position: 'absolute',
                    height: '100%',
                } }, { children: [_jsx("path", { d: "M0,0 0,0 16,0.5 0,1 0,1z" }), _jsx("line", { x1: "0", x2: "16", y1: "0", y2: "0.5", stroke: "#a7a7a7", strokeWidth: "0.05", strokeLinecap: "butt" }), _jsx("line", { x1: "0", x2: "16", y1: "1", y2: "0.5", stroke: "#a7a7a7", strokeWidth: "0.1", strokeLinecap: "butt" })] }))] })));
};
